import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { byAppVariant } from '@/consts/AppVariants';
import noGamesFoundChristmas from '@/public/assets/image/global-states/empty/christmas/empty-christmas-state.webp';
import noGamesFoundBase from '@/public/assets/image/global-states/empty/default/empty-default-state.webp';
import { cn } from '@/utils/cn';

interface Props {
  imageClassName?: string;
  className?: string;
}

export default function EmptyGamesState({ imageClassName, className }: Props) {
  const t = useTranslations('lobby.filters');
  const noGamesFound = byAppVariant({
    christmas: noGamesFoundChristmas,
    default: noGamesFoundBase,
  });

  return (
    <>
      <div className={cn('relative isolate flex flex-col items-center mb-7.5 lg:gap-3.75 lg:mt-4.75 gap-0', className)}>
        <div className="absolute -top-1.5 sm:top-[9%] lg:-top-1.5 w-28.25 sm:w-full sm:max-w-50 lg:w-28.25 lg:max-w-none sm:h-43 lg:h-32 -z-1 h-32 rounded-full blur-2xl opacity-80 pointer-events-none bg-main-back-gradient" />
        <Image
          src={noGamesFound}
          alt="no-games-found"
          width={600}
          height={480}
          className={cn('w-37.5 h-30 object-cover sm:w-full sm:max-w-62.5 sm:h-auto sm:object-contain lg:w-37.5 lg:max-w-none lg:h-30 lg:object-cover', imageClassName)}
        />
        <p className="text-white font-regular text-[1rem] max-lg:-mt-2.25 leading-6 text-center lg:font-regular lg:text-lg lg:leading-7">
          {t.rich('we-couldnt-find-the-game-youre-looking-for', {
            br: () => <span className="lg:hidden"><br /></span>,
          })}
        </p>
      </div>
    </>
  );
}
